<template>
  <div ref="scriptSection" />
</template>

<script>

export default {
    props: {
        script: {
            type: Object,
            required: true,
        },
    },

    computed: {
        productType() {
            return this.$store.state.page.productType;
        },

        cookieConsent() {
            return this.$store.state.page.cookieConsent;
        },
    },

    watch: {
        cookieConsent: {
            handler() {
                this.createScriptBasedOnConsent();
            },
        },
    },

    mounted() {
        this.$nextTick(() => {
            if (this.productType === 'marketplaces') {
                if (this.script.consent === 'no_consent_required') {
                    this.loadScript();
                    return;
                }

                this.createScriptBasedOnConsent();
            } else {
                this.loadScript();
            }
        });
    },

    methods: {
        createScriptBasedOnConsent() {
            const cookieConsent = JSON.parse(this.cookieConsent);

            if (cookieConsent[this.script.consent] === 'granted') {
                this.loadScript();
            }

            if (cookieConsent[this.script.consent] === 'denied') {
                this.setInnerHTML(this.$refs.scriptSection, '');
            }
        },

        loadScript() {
            this.setInnerHTML(this.$refs.scriptSection, this.script.script);
        },

        setInnerHTML(elm, html) {
            elm.innerHTML = html;

            Array.from(elm.querySelectorAll('script')).forEach( oldScriptEl => {
                const newScriptEl = document.createElement('script');

                Array.from(oldScriptEl.attributes).forEach( attr => {
                    newScriptEl.setAttribute(attr.name, attr.value);
                });

                const scriptText = document.createTextNode(oldScriptEl.innerHTML);
                newScriptEl.appendChild(scriptText);

                oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
            });
        },
    },
};
</script>
